const Data = [
    {
      id: 1,
      category: "education",
      icon: "icon-graduation",
      year: "2023",
      title: "Simon Fraser University",
      desc: "Bachelor's of Science in Mathematics and Computer Science",
    },
    // {
    //   id: 2,
    //   category: "education",
    //   icon: "icon-graduation",
    //   year: "2013 - 2017",
    //   title: "Bachelor's Degree",
    //   desc: "Lorem ipsum dolor sit amet quo ei simul congue exerci     ad nec admodum perfecto.",
    // },
    // {
    //   id: 3,
    //   category: "education",
    //   icon: "icon-graduation",
    //   year: "2009 - 2013",
    //   title: "Honours Degree",
    //   desc: "Lorem ipsum dolor sit amet quo ei simul congue exerci     ad nec admodum perfecto.",
    // },
    {
      id: 2,
      category: "experience",
      icon: "icon-briefcase",
      year: "Feb 2025 - Present",
      title: "Saatchi & Saatchi - Software Engineer",
      desc: "Development of internal tooling system for Toyota.",
    },
    {
      id: 3,
      category: "experience",
      icon: "icon-briefcase",
      year: "Sept 2023 - Dec 2024",
      title: "StarGarden - Software Developer",
      desc: "Development of Human Resources Information Systems (HRIS) web application.",
    },
    {
      id: 4,
      category: "experience",
      icon: "icon-briefcase",
      year: "Jan 2023 - Aug 2023",
      title: "Trulioo - Software Engineer Intern",
      desc: "Software engineer for the KYB (Know-Your-Business) team, focusing on software solutions for business verification.",
    },
    {
      id: 5,
      category: "experience",
      icon: "icon-briefcase",
      year: "Jan 2022 - Aug 2022",
      title: "Healthcare Systems R&A - Software & ML Engineer Intern",
      desc: "Developed mobile camera application that analyzes confidence of a Rapid Diagnostic Test Strip (COVID-19).",
    },
    {
      id: 6,
      category: "experience",
      icon: "icon-briefcase",
      year: "Jan 2021 - Aug 2021",
      title: "Motorola Solutions - Software Test Developer Intern",
      desc: "Developed automated tests for video management software and hardware (cameras).",
    },
  ];

export default Data